var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.335937,
    y: 0.335937,
    width: 22.1719,
    height: 15.4531,
    rx: 2.35156,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.671874
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4973 12.3825C17.0133 12.3825 19.053 10.3671 19.053 7.88095C19.053 5.39481 17.0133 3.37939 14.4973 3.37939C13.3696 3.37939 12.3377 3.78421 11.5421 4.45478C10.7466 3.78421 9.71465 3.3794 8.58702 3.3794C6.07094 3.3794 4.03125 5.39482 4.03125 7.88096C4.03125 10.3671 6.07094 12.3825 8.58702 12.3825C9.71466 12.3825 10.7466 11.9777 11.5421 11.3071C12.3377 11.9777 13.3696 12.3825 14.4973 12.3825Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5421 11.3072C12.5217 10.4815 13.1428 9.2529 13.1428 7.88095C13.1428 6.50901 12.5217 5.28041 11.5421 4.45474C12.3376 3.78419 13.3696 3.37939 14.4972 3.37939C17.0133 3.37939 19.053 5.39481 19.053 7.88095C19.053 10.3671 17.0133 12.3825 14.4972 12.3825C13.3696 12.3825 12.3376 11.9777 11.5421 11.3072Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5422 11.3069C12.5217 10.4813 13.1428 9.2527 13.1428 7.88077C13.1428 6.50884 12.5217 5.28026 11.5422 4.45459C10.5626 5.28026 9.94153 6.50884 9.94153 7.88077C9.94153 9.2527 10.5626 10.4813 11.5422 11.3069Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.a3cf65d0fb699066e8755cd4ce342184.svg";
export { ForwardRef as ReactComponent };